export const UPDATE_FETCHING = 'UPDATE_FETCHING';
export const UPDATE_UPLOADING = 'UPDATE_UPLOADING';
export const FETCH_ERROR = 'FETCH_ERROR';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const UPDATE_QUEUE_STALLED = 'UPDATE_QUEUE_STALLED';

export type StatusBarActionTypes = 'UPDATE_FETCHING' | 'UPDATE_UPLOADING' | 'FETCH_ERROR' | 'FETCH_SUCCESS' | 'UPDATE_QUEUE_STALLED';

export type StatusBarActions = {
    type: StatusBarActionTypes;
    isFetching: boolean;
    isUploading: boolean;
    fetchErrorMessage: any;
    queueStalled: boolean;
    payload: {
        fetchCount: number;
        totalFetchCount: number;
    }
}

/**
 * Update fetching status with true (fetch in progress) or false (no fetch in progress)
 *
 * @param {boolean} isFetching
 * @returns {{type: string, isFetching: boolean}}
 */
export const updateFetching = (isFetching: boolean): { type: StatusBarActionTypes; isFetching: boolean; } => {
    return {type: UPDATE_FETCHING, isFetching: isFetching};
};

/**
 * Update upload status with true (uploads in progress) or false (no uploads)
 *
 * @param {boolean} isUploading
 * @returns {{type: string, isFetching: boolean}}
 */
export const updateUploading = (isUploading: boolean): { type: string; isUploading: boolean; } => {
    return {type: UPDATE_UPLOADING, isUploading};
};

export const fetchError = (fetchErrorMessage: any) => {
    return {type: FETCH_ERROR, fetchErrorMessage};
};

export const fetchSuccess = (fetchCount = 0, totalFetchCount = 0) => {
    return {type: FETCH_SUCCESS, payload: {fetchCount, totalFetchCount}};
};

/**
 * Update queue-stalled status. True when an item has been pending for longer
 * than QUEUE_STALL_THRESHOLD_MS without making progress (and isn't in healthy
 * backoff). Drives the StatusBar maroon indicator.
 */
export const updateQueueStalled = (queueStalled: boolean): { type: StatusBarActionTypes; queueStalled: boolean; } => {
    return {type: UPDATE_QUEUE_STALLED, queueStalled};
};

